/* eslint-disable react-redux/no-unused-prop-types */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
class FieldPropTypes extends React.Component {
  render() {
    return null;
  }
}
FieldPropTypes.propTypes = {
  /**  `true` if the field is focused. */
  active: PropTypes.bool,
  /** The current error code associated with the field. */
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  /** A map of the error types to the messages you want to render.
   * Use `validator.errorTypes` from `/forms`. */
  errorMessages: PropTypes.shape({
    REQUIRED: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    INVALID_FORMAT: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    BELOW_MIN_DATE: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    ABOVE_MAX_DATE: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    DATE_RANGE_ORDER: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    BELOW_MIN_NUMBER: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    ABOVE_MAX_NUMBER: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    BELOW_MIN_ITEMS: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    ABOVE_MAX_ITEMS: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
  }),
  /** `true` if the field should be hidden in the `Form` */
  ignore: PropTypes.bool,
  /** can be used to determine which error messages to show, use `inputTypes` from `/forms` */
  inputType: PropTypes.string,
  /** The `name` of field you want controlled by the form. Must correspond
   * with the key used in `Form`'s `initialFieldState`. */
  name: PropTypes.string,
  /** A `Form` method that handles field state updates. */
  onUpdate: PropTypes.func,
  /** A unique identifier for the field. If none is provided, one will be generated. */
  id: PropTypes.string,
  /** `true` if the field is required. */
  required: PropTypes.bool,
  /** `true` if the field has been focused and then blurred. */
  touched: PropTypes.bool,
  /** Function called to determine field error state. */
  validate: PropTypes.func,
  /** called onBlur. only for handling side effects. Recieves field state. */
  watchBlur: PropTypes.func,
  /** called onChange. only for handling side effects. Recieves field state. */
  watchChange: PropTypes.func,
  /** called onFocus. only for handling side effects. Recieves field state. */
  watchFocus: PropTypes.func
};
export { FieldPropTypes };